import React, { useState } from "react";
import "../styles/AccountMapping.css";

const dummyAccounts = {
  12345: {
    accountHolder: "Natul",
    accountType: "DD",
  },
  123456: {
    accountHolder: "Rahul Sharma",
    accountType: "SA",
  },
};

const agents = [
  { id: 1, name: "Agent A" },
  { id: 2, name: "Agent B" },
  { id: 3, name: "Agent C" },
];

export default function AccountMapping() {
  const [accountNo, setAccountNo] = useState("");
  const [accountDetails, setAccountDetails] = useState(null);
  const [selectedAgent, setSelectedAgent] = useState("");

  const handleFetchDetails = () => {
    const details = dummyAccounts[accountNo];
    if (details) {
      setAccountDetails(details);
    } else {
      setAccountDetails({
        accountHolder: "Not Found",
        accountType: "N/A",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Mapped ${accountNo} to ${selectedAgent}`);
  };

  return (
    <div className="account-mapping-page">
      <h2 className="page-title">Account Mapping</h2>

      <form className="mapping-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>Account Number</label>
          <div className="input-fetch-group">
            <input
              type="text"
              value={accountNo}
              onChange={(e) => setAccountNo(e.target.value)}
              placeholder="Enter Account Number"
              required
            />
            <button type="button" onClick={handleFetchDetails}>
              Fetch Details
            </button>
          </div>
        </div>

        {accountDetails && (
          <div className="account-details-box">
            <h4>Account Details</h4>
            <div className="detail-row">
              <span>Account Number:</span>
              <span>{accountNo}</span>
            </div>
            <div className="detail-row">
              <span>Account Holder:</span>
              <span>{accountDetails.accountHolder}</span>
            </div>
            <div className="detail-row">
              <span>Account Type:</span>
              <span>{accountDetails.accountType}</span>
            </div>
          </div>
        )}

        <div className="form-row">
          <label>Select Agent</label>
          <select
            value={selectedAgent}
            onChange={(e) => setSelectedAgent(e.target.value)}
            required
          >
            <option value="">Select an agent</option>
            {agents.map((agent) => (
              <option key={agent.id} value={agent.name}>
                {agent.name}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
}
